import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  CssBaseline,
  ThemeProvider
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link as RouterLink } from 'react-router-dom';
import { BasePage } from 'src/components/Page';
import GlobalStyles from 'src/components/GlobalStyles';
import useSettingsContext from 'src/hooks/useSettingsContext';
import { createMuiTheme } from 'src/theme';
import config from 'src/config';

const { errorMessage } = config;

const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: theme.palette.background.default,,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  image: {
    marginTop: 70,
    display: 'inline-block',
    maxWidth: '100%',
    width: 460,
    marginBottom: 80
  }
}));

const RouterErrorViewContent = () => {
  const classes = useStyles();

  return (
    <BasePage className={classes.root} title="Something went wrong">
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="md">
          <Typography align="center" color="textPrimary" variant="h1">
            Something went wrong.
          </Typography>
          <Typography align="center" color="textPrimary" variant="subtitle2">
            {errorMessage}
          </Typography>
          <Box textAlign="center">
            <img
              alt="Not Found"
              className={classes.image}
              src="/static/images/broken.svg"
            />
          </Box>
          <Box textAlign="center" marginTop={5}>
            <Button
              color="primary"
              component={RouterLink}
              to="/"
              variant="outlined"
              startIcon={<ArrowBackIcon />}
            >
              Go Back
            </Button>
          </Box>
        </Container>
      </Box>
    </BasePage>
  );
};

const RouterErrorView = () => {
  const { settings } = useSettingsContext();
  const theme = createMuiTheme({
    theme: settings.theme
  });

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <CssBaseline />
      <RouterErrorViewContent />
    </ThemeProvider>
  );
};

export default RouterErrorView;
